module.exports = __webpack_public_path__ + "fonts/iconfont.a906f926.eot";